import React, { 
  useState, 
  useEffect 
} from 'react'
import { 
  useParams, 
  Outlet 
} from 'react-router-dom'
import { useGame } from 'data/hooks'

import { 
  Menu 
} from 'basecomps'

import playmotivlogo from 'assets/logo/playmotiv-logo-monocolor-black.svg'

export const Game = props => {

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { 
    game,
    refresh, 
    role 
  } = useGame(gameId)
  
  let menuwaittime = new Date().getTime()

  useEffect(() => {

    if (!gameId) return

    // Esto se hace para que los registros de LOG pillen el game correcto en entornos multi-game
    window.playmotiv.game = window.playmotiv.game || {}
    window.playmotiv.game.gameId = gameId

  }, [gameId])

  useEffect(() => {

    if (props.setTitle) props.setTitle(game.title)

    if(!game?.menu) { // Wait menu & stop if time > 1.2 sec (in case of game has no menu assigned)

      const newmenuwaittime = new Date().getTime()
      const diff = newmenuwaittime - menuwaittime

      if(diff > 1500)  {
        
        refresh()
      }
    }

  }, [game])

  return (<>
    {
      game && 
      <div className={
        `game ${game.tags.split(',').join(' ')} ${ role }`
      }>
        <div className={`
          game-wrapper
          ${ 
            game.menu && 
            game.menu !== '' ?
            'withmenu'
            :
            ''
          }
        `}>
          <Outlet context={{
            showhelpcontent: props.showhelpcontent
          }} />
        </div>
        {
          game.menu && 
          game.menu !== '' &&
          <div className="game-menu-wrapper">
            <Menu 
              className="game-menu"
              centered={ true }
              slug={ game.menu }
              tabPosition="bottom"
              mode="horizontal"
              type="gamemenu"
              avoidreselect={ props.avoidreselect }
            />
          </div>
        }
        <div className="footer">
          <div className="game-logo">
            {
              window.playmotiv.logo &&
              <img src={window.playmotiv.logo} />
            }
          </div>
          <div className="playmotiv-logo">
            <img src={playmotivlogo} />
          </div>
        </div>
      </div>
    }
  </>)
}
